import React from 'react'
import type { AssistantCitation } from '@services/api/aiAssistant.api'

// Render only provider citation annotations as links; never interpret generated HTML.
export const AssistantAnswer = ({
  content,
  citations = [],
}: {
  content: string
  citations?: AssistantCitation[]
}): React.ReactElement => {
  const parts: React.ReactNode[] = []
  let position = 0
  for (const citation of [...citations].sort(
    (a, b) => a.start_index - b.start_index,
  )) {
    const { start_index: start, end_index: end } = citation
    if (
      !Number.isInteger(start) ||
      !Number.isInteger(end) ||
      start < position ||
      end <= start ||
      end > content.length
    )
      continue
    let url: URL
    try {
      url = new URL(citation.url)
    } catch {
      continue
    }
    if (
      !['https:', 'http:'].includes(url.protocol) ||
      url.username ||
      url.password
    )
      continue
    parts.push(content.slice(position, start))
    parts.push(
      <a
        key={`${start}-${end}`}
        href={url.href}
        target="_blank"
        rel="noopener noreferrer"
        title={citation.title}
      >
        {citation.title || url.hostname}
      </a>,
    )
    position = end
  }
  parts.push(content.slice(position))
  return <>{parts}</>
}
